/**
 * Honest OAuth / reconnect copy (Wave 11.3 B6 / DEC-S18).
 * Codes come from redirect ?error= or sync taxonomy reasons.
 */

const OAUTH_ERROR_COPY = {
  google_ads_failed:
    "Google Ads connection failed. Please try again — if this keeps happening, check that you granted access.",
  meta_ads_failed:
    "Meta Ads connection failed. Please try again — if this keeps happening, check that you granted access.",
  linkedin_ads_failed:
    "LinkedIn Ads connection failed. Please try again — if this keeps happening, check that you granted access.",
  access_denied:
    "You didn’t grant access. Connect again when you’re ready — we can’t sync without permission.",
  user_cancelled:
    "Connection cancelled. Nothing was linked — connect again when you’re ready.",
  PAIRING_UNPROVEN:
    "We couldn’t prove access to this Google Ads account with the saved route. Pick the account again.",
  PAIRING_FAILED:
    "We couldn’t prove access to this Google Ads account. Try another account or reconnect.",
  RECONNECT_REQUIRED:
    "Google says this account is no longer reachable with the current authorization — reconnect to re-authorize.",
  PERMISSION:
    "Google denied access to this account via the current manager route — reconnect to re-authorize.",
  TOKEN_REFRESH_FAILED:
    "Your Google Ads session expired and couldn’t be refreshed — reconnect to continue syncing.",
};

/**
 * @param {string | null | undefined} code
 * @returns {string}
 */
export function oauthErrorMessage(code) {
  if (!code || typeof code !== "string") {
    return "Connection failed. Please try again.";
  }
  const key = code.trim();
  return (
    OAUTH_ERROR_COPY[key] ||
    `Connection failed (${key}). Please try again.`
  );
}

/**
 * @param {string | null | undefined} code
 * @returns {string | null}
 */
export function reconnectReasonMessage(code) {
  if (!code || typeof code !== "string") return null;
  const key = code.trim();
  if (OAUTH_ERROR_COPY[key]) return OAUTH_ERROR_COPY[key];
  return null;
}
